import type { UploadConnectionType } from "./types";

/**
 * Collapse platform-specific radios into the three warehouse values. Ethernet
 * and wimax share wifi's unmetered bucket — the question these events answer
 * is "poor cellular vs not", not the physical medium. VPN/bluetooth/other
 * are omitted rather than guessed.
 */
export const mapUploadConnectionType = (input: {
  type?: string | null;
  isConnected?: boolean | null;
  isOnline?: boolean;
}): UploadConnectionType | undefined => {
  if (
    input.isConnected === false ||
    input.isOnline === false ||
    input.type === "none"
  ) {
    return "offline";
  }
  switch (input.type) {
    case "wifi":
    case "ethernet":
    case "wimax":
      return "wifi";
    case "cellular":
      return "cellular";
    default:
      return undefined;
  }
};

export const connectionTypeField = (
  connectionType: UploadConnectionType | undefined,
): { connectionType?: UploadConnectionType } =>
  connectionType === undefined ? {} : { connectionType };
